module.exports = __webpack_public_path__ + "static/media/Codependency.ec0df947.svg";